// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#newClientModal .suggest-item-vetter .hover,#newClientModal .suggest-item-vetter .selected{background-color:#0097cf!important}#newClientModal .vue-simple-suggest.designed .suggestions{overflow:scroll;max-height:350px}", ""]);
// Exports
module.exports = exports;
